import { environment } from '@env/environment';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class CustomMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        if (environment.production === false) {
            console.warn(`Missing translation for key: ${params.key}`);
        }
        return params.key;
    }
}
